<template>
  <RouterView />
  <AppConfirmProvider />
</template>

<script setup lang="ts">
import { watch } from 'vue'
import { AppConfirmProvider } from '@/components/dialog'
import { useRouter } from 'vue-router'
import { useAuthStore } from './stores/auth'

const authStore = useAuthStore()
const router = useRouter()

// If session ends without a successful route change (e.g. aborted navigation), leave no stale protected UI.
watch(
  () => authStore.isAuthenticated,
  (authenticated) => {
    if (authenticated) return
    const route = router.currentRoute.value
    const requiresAuth = route.matched.some((r) => r.meta?.requiresAuth)
    if (!requiresAuth) return
    void router.replace({ name: 'login' }).catch(() => {})
  },
)
</script>

<style lang="scss">
#app {
  font-family: 'Inter', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  min-width: 20rem;
}
</style>
